export const PrivacyPolicyActionTypes = {
  API_RESPONSE_SUCCESS: '@@privacy-policy/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@privacy-policy/API_RESPONSE_ERROR',

  UPDATE_PRIVACY_POLICY: '@@privacy-policy/UPDATE_PRIVACY_POLICY',

  RESET: '@@privacy-policy/RESET'
}
